// Project invitations (online-only, P13). Links have a fixed shape `/invite/{id}.{mac}` on the brand's canonical
// origin; after accepting, the app only ever navigates to an internal `/w/{workspaceId}` path returned by the
// server and validated here — never to a URL taken from the address bar or query string (no open redirects).
import { api } from '@/api/client';

export interface InvitePreview { status: 'pending' | 'accepted' | 'revoked' | 'expired'; project_name: string; inviter_name: string; email_hint: string; role: string; expires_at: string }
export interface InviteAccepted { workspace_id: string; project_id: string; role: string; path: string }

const TOKEN = /^\/invite\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.[A-Za-z0-9_-]{43})\/?$/;
const APP_PATH = /^\/w\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export function inviteTokenFromPath(pathname: string): string | null {
  return TOKEN.exec(pathname)?.[1] ?? null;
}

/** Only `/w/{uuid}` is accepted; anything else (absolute URLs, `//host`, `javascript:`, traversal) falls back to `/`. */
export function safeAppPath(path: unknown): string {
  return typeof path === 'string' && APP_PATH.test(path) ? path : '/';
}

export const previewInvitation = (token: string) => api<InvitePreview>('GET', '/invitations/' + encodeURIComponent(token));
export const acceptInvitation = (token: string) => api<InviteAccepted>('POST', '/invitations/' + encodeURIComponent(token) + '/accept');
